import React from 'react'

export default function NotFound(){
	return (
		<div className="body_container padded_top padded_bottom">
			<h1 className="no-margin">Page not found</h1>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js